import { render, staticRenderFns } from "./heroDetail.vue?vue&type=template&id=18bee5e9&"
import script from "./heroDetail.vue?vue&type=script&lang=js&"
export * from "./heroDetail.vue?vue&type=script&lang=js&"
import style0 from "./heroDetail.vue?vue&type=style&index=0&id=18bee5e9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports